module.exports = "<svg width=\"10\" height=\"8\" viewBox=\"0 0 10 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 0L9.33013 7.5H0.669873L5 0Z\" fill=\"white\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/polygon.svg
// module id = 873
// module chunks = 0